import React, { useEffect, useState } from 'react'
import ConfigureSlotModal from '../modals/ConfigureSlotModal';
import { Add } from '@mui/icons-material';
import Forward from './Forward';
import TwilanswerApp from './TwilanswerApp';
import RingBrowser from './RingBrowser';
import IvrMenu from './IvrMenu';
import SendToVoicemail from './SendToVoicemail';
import PlayRecording from './PlayRecording';
import ElevenLabs from './ElevenLabs';
import { isForwardFamilyAction } from '../../utils/forwardActionMode';
import {
  EMPTY_DEVICE_SENTINEL,
  TWILANSWER_APP_ACTION,
  isDeviceSentinel,
  isTwilanswerAppAction,
} from '../../utils/forwardDeviceDestinations';

const PrimaryCallAction = ({
    route,
    setRoute,
    setSnackMsg,
    setOpenSnack,
    setLoader,
    enableBusinessHours = false,
    hasValidationError = false,
  }) => {


    const [openConfigureSlotModal, setOpenConfigureSlotModal] = useState(false)
    const [slot, setSlot] = useState(null)



    useEffect(()=> {

        if(slot == 'ivr'){
            setRoute({...route, primaryAction: 'ivr', ivrMenu : {
                options: {
                    "1": {
                        digit: "1",
                        id: "press_1",
                        name: "Press 1",
                        primaryAction: null,
                        notification: null,
                      },
                },
            }})
        }

        if(slot =='forward'){
                setRoute({
                  ...route,
                  primaryAction: slot,
                  primaryChannel: null,
                  ringTarget: null,
                  ringGroup: null,
                  ringUser: null,
                  ivrMenu: null,
                  ...(isDeviceSentinel(route?.primaryNumber)
                    ? { primaryNumber: null }
                    : {}),
                })

        }

        if(slot === TWILANSWER_APP_ACTION){
            setRoute({
              ...route,
              primaryAction: TWILANSWER_APP_ACTION,
              primaryChannel: null,
              ringTarget: null,
              ringGroup: null,
              ringUser: null,
              ivrMenu: null,
              primaryNumber: isDeviceSentinel(route?.primaryNumber)
                ? route.primaryNumber
                : EMPTY_DEVICE_SENTINEL,
              twilanswerVmFallback: Boolean(route?.primaryRecording),
            })
        }

        if(slot =='ring_browser'){
            setRoute({...route, primaryAction: slot , primaryChannel:null, primaryNumber: null, callerIdPref: null, ivrMenu: null})
    }

    if(slot =='send_to_vm'){
        setRoute({...route, primaryAction: slot , primaryChannel:null, primaryNumber: null, callerIdPref: null, ivrMenu: null, ringGroup: null, ringUser: null})
    }

    if(slot =='play_recording'){
        setRoute({...route, primaryAction: slot , primaryChannel:null, primaryNumber: null, callerIdPref: null, ivrMenu: null, ringGroup: null, ringUser: null})
    }

    if(slot =='ai_agent'){
        setRoute({...route, primaryAction: slot , primaryChannel:null, primaryNumber: null, callerIdPref: null, ivrMenu: null, ringGroup: null, ringUser: null})
    }

    }, [slot])
  return (
    <div className=" w-full">
         

          <div className="text-[12px] font-semibold text-gray-500 mb-2">
           DURING BUSINESS HOURS 
          </div>
          

          <ConfigureSlotModal
            open={openConfigureSlotModal}
            onClose={setOpenConfigureSlotModal}
            slot={setSlot}
            route={route}
          />

          {!route?.primaryAction && (
            <div className={`rounded-lg border border-gray-200 py-8 px-4 shadow-sm ${hasValidationError ? "bg-red-50/80" : "bg-white"}`}>
              <div
                className="border-2 border-dashed border-gray-300 rounded-lg cursor-pointer 
                     flex items-center justify-center h-16 hover:border-gray-400 transition"
                onClick={() => setOpenConfigureSlotModal(true)}
              >
                <Add className="text-gray-500 mr-2" />
                <span className="text-gray-600">Add Call Action</span>
              </div>
            </div>
          )}

{route?.primaryAction == "ivr" && (
           <IvrMenu route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} enableBusinessHours={enableBusinessHours} />
          )}

          {isTwilanswerAppAction(route?.primaryAction) && (
           <TwilanswerApp route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} />
          )}

          {isForwardFamilyAction(route?.primaryAction) && (
           <Forward route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} /> 
          )}

          {route?.primaryAction == "ring_browser" && (
           <RingBrowser route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} /> 
          )}

          {route?.primaryAction == "send_to_vm" && (
           <SendToVoicemail route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} /> 
          )}

          {route?.primaryAction == "play_recording" && (
           <PlayRecording route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} /> 
          )}

          {route?.primaryAction == "ai_agent" && (
           <ElevenLabs route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} /> 
          )}

          
        </div>
  )
}

export default PrimaryCallAction
